<ng-template #header>
    <shared-vcard-for-order [orderId]="modalData.transactionId" [showOrderId]="false" [preTitle]="preTitle">
        {{title$ | async}}<ng-container *ngIf="locationName$ | async"><br />{{locationName$ | async}}</ng-container>
    </shared-vcard-for-order>
</ng-template>

<ng-template #footer>
    <shared-modal-item-actions [empty]="true">
    </shared-modal-item-actions>
</ng-template>

<shared-modal-type-dynamic-height (onScrollInit)="handleScrollInit($event)" (onScrollY)="handleScrollY($event)"
    [dimmedBg]="dimmedBg" [shadow]="shadow" [footer]="footer" [size]="size" [header]="header" [minHeight]="minHeight"
    [modalData]="modalData" [center]="true" [fullPaddings]="fullPaddings" (onCloseClick)="handleCloseClick($event)"
    class="modal-view-for-transaction">

    <shared-order-full-summary [transactionId]="modalData.transactionId" [bottomPadding]="true">
    </shared-order-full-summary>

</shared-modal-type-dynamic-height>